// src/service/businessType/BusinessTypeService.ts
import { get, post } from "../../utils/BaseService";

export interface BusinessType {
  business_type_id: number;
  name: string;
  description: string;
}

export interface CreateGSTRate{
  gstTreatmentId: number;
  gstRateName: string;
  gstNameVal: number;
  tax_type: string|null;
}

export async function getAllBusinessTypes(dispatch: any): Promise<BusinessType[]> {
  return await get(dispatch, '/businessType/getAll', null);
}
export async function isSameExistByNameOrVal(dispatch: any,input:CreateGSTRate): Promise<BusinessType[]> {
  return await get(dispatch, '/businessType/isSameExistByNameOrVal', input);
}
export async function getAllGSTRatesByName(dispatch: any,input:{businessTypeName:string}): Promise<{gstRates:{name:string,value:number}[]}> {
  return await get(dispatch, '/businessType/getAllGSTRatesByName', input);
}
export async function createGSTRatesInGSTTreatment(dispatch: any,input:CreateGSTRate): Promise<string> {
  return await post(dispatch, '/businessType/createGSTRatesInGSTTreatment', input);
}

export async function getBusinessTypeById(dispatch: any, id: number): Promise<BusinessType | null> {
  return await get(dispatch, `/businessTypes/getById/${id}`, null);
}